const initialState = () => ({
  schedules: [], // Listado de agendas
})

export default initialState
